import { render, staticRenderFns } from "./courseFile.vue?vue&type=template&id=1ce84259&scoped=true"
import script from "./courseFile.vue?vue&type=script&lang=js"
export * from "./courseFile.vue?vue&type=script&lang=js"
import style0 from "./courseFile.vue?vue&type=style&index=0&id=1ce84259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce84259",
  null
  
)

export default component.exports